<template>
  <f-loader ref="loader">
    <div class="container w-50 mx-auto">
      <div class="d-flex flex-column gap-5">
        <chat-widget v-if="active&&chatServer" :chat-server="chatServer" :secret-token="secretToken" :pid="pid" :uid="uid" :meta="$route.query" class="mt-5" style="height: 75vh"/>
        <button @click="newSession" class="btn btn-outline-secondary">Новый чат</button>
      </div>
    </div>
  </f-loader>
</template>

<script>

import ChatWidget from "@/components/widget/ChatWidget";
import {http, make_query} from "@/misc/http";
import FLoader from "@/components/FLoader";
import {config} from "@/state/config";

export default {
  components: {FLoader, ChatWidget},
  props: ["pid", "uid"],
  data() {
    return {
      active: false,
      chatServer: "",
      secretToken: "",
    }
  },
  async mounted() {
    document.title = "User " + this.uid + " (project " + this.pid + ")";
    const query = this.$route.query;

    if (query["reset"]) {
      delete query["reset"];
      localStorage.removeItem("session" + this.uid);
      window.location = window.location.href.split("?")[0] + "?" + make_query(query);
    }

    this.secretToken = config.chatServer.secretToken;
    const chatServerHost = config.chatServer.chatServerHost || window.location.hostname;
    const chatServerPort = config.chatServer.chatServerPort || "80";
    const chatServerProto = config.chatServer.chatServerProto || "ws";

    this.chatServer = chatServerProto + "://" + chatServerHost + ":" + chatServerPort;

    this.active = true;

  },
  methods: {
    newSession() {
      localStorage.removeItem("session" + this.uid);
      location.reload();
    }
  },
}
</script>

